
<script>
import http from '@/service/http'
import { mapState } from 'vuex'
export default {
  name: 'Form',
  data () {
    return {
      forma: {
        id: '',
        forma: '',
        ativo: true
      }
    }
  },
  mounted () {
    this.fecth()
  },
  watch: {
    '$route' () {
      if (this.$route.params.id != null) {
        this.fecth()
      }
    },
    hasAll () {
      if (this.hasAll) {
        this.all = true
      } else {
        this.all = false
      }
    }
  },
  methods: {
    validate () {
      this.$validator.validateAll().then(success => {
        if (!success) {
          return false
        } else {
          this.submit()
        }
      })
    },
    async submit () {
      const verb = this.isNew ? 'post' : 'put'
      const url = this.isNew ? '/financeiro/formas' : `/financeiro/formas/${this.forma.id}`
      const { data } = await http[verb](url, this.forma)
      if (data != null) {
        this.$emit('update-financeiro-formas-list', { forma: data.forma })
        this.$router.push({ name: 'financeiro-formas.index' })
      }
    },
    async fecth () {
      this.clear()
      const { id } = this.$route.params
      if (id !== undefined) {
        const { data } = await http.get(`/financeiro/formas/${id}/edit`)
        this.forma = data.forma
        setTimeout(function () {
          window.Materialize.updateTextFields()
        }, 0)
      }
    },
    clear () {
      this.forma = {
        id: '',
        forma: '',
        ativo: true
      }
    }
  },
  computed: {
    ...mapState(['loading']),
    isNew () {
      return this.forma.id === ''
    }
  }
}
</script>

<template>
  <div>

    <form @submit.prevent="validate">

      <div class="row">

        <div class="col s12 m10 offset-m1">

          <div class="row">
            <div class="input-field col s12 m10">
              <input name="forma" id="forma" type="text" v-validate data-vv-rules="required" :class="{invalid: errors.has('forma')}" v-model="forma.forma">
              <label for="forma">*Forma de Pagamento</label>
              <small class="red-text">{{ errors.first('forma') }}</small>
            </div>
            <div class="input-field col s12 m2">
              <input name="ativo" id="ativo" type="checkbox" v-model="forma.ativo">
              <label for="ativo">Ativo</label>
            </div>
          </div>

          <div class="row">

            <div class="input-field col s12">
              <button class="waves-effect waves-light btn" :disabled="loading">Salvar</button>
            </div>

          </div>

        </div>

      </div>

    </form>

  </div>
</template>



// WEBPACK FOOTER //
// src/features/financeiro/formas/form.vue